import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

class FilterButtonGroup extends React.Component {
  handleButtonClick = (value) => () => {
    const { handleClickEvent } = this.props;

    if (handleClickEvent) {
      handleClickEvent(value);
    }
  }

  renderButtons = () => {
    const { filterConfig, value } = this.props;

    if (!filterConfig) {
      return [];
    }

    return [filterConfig.map((filterConfigItem) => (
      <ButtonGroup key={filterConfigItem.filterValue}>
        <Button
          variant="outline-secondary"
          className={'btn btn-default' + (filterConfigItem.filterValue === value ? ' active' : '')}
          style={{ color: 'var(--bs-btn-border-color)' }}
          onClick={this.handleButtonClick(filterConfigItem.filterValue)}
          value={filterConfigItem.filterValue}
        >
          {filterConfigItem.filterTitle}
        </Button>
      </ButtonGroup>
    ))];
  };

  render() {
    return (
      <div
        className="btn-group"
        role="group"
        id={this.props.id}
      >
        {this.renderButtons()}
      </div>
    );
  }
}

FilterButtonGroup.propTypes = {
  handleClickEvent: PropTypes.func,
  filterConfig: PropTypes.array,
  value: PropTypes.string,
  id: PropTypes.string,
};

export default FilterButtonGroup;